import { useCourseAdminSummary } from "../hooks/useCourses";
import { CoursesChart } from './charts/CoursesChart';

export default function CourseSummary() {
    const { data } = useCourseAdminSummary();

    return data ? <CoursesChart labels={data.map((c) => c.title)} count={data.map((c) => c.count)} /> : null;
}